import {
  createAction,
  joinActions,
  props,
} from "../../helpers/store/actions-helpers";
import { InstagramLoginSetting } from "../interface/api/instagram-login-api";

export const postUnbindInstagramLoginInitAction = createAction(
  "[InstagramLogin] Unbind Init"
);
export const postUnbindInstagramLoginSuccessAction = createAction(
  "[InstagramLogin] Unbind Success"
);
export const postUnbindInstagramLoginFailureAction = createAction(
  "[InstagramLogin] Unbind Failure",
  props<{ error: string }>()
);

export const postBindInstagramLoginInitAction = createAction(
  "[InstagramLogin] Bind Init"
);
export const postBindInstagramLoginSuccessAction = createAction(
  "[InstagramLogin] Bind Success",
  props<{ settings: InstagramLoginSetting }>()
);
export const postBindInstagramLoginFailureAction = createAction(
  "[InstagramLogin] Bind Failure",
  props<{ error: string }>()
);

export const getInstagramLoginInitAction = createAction(
  "[InstagramLogin] Get Settings Init"
);
export const getInstagramLoginSuccessAction = createAction(
  "[InstagramLogin] Get Settings Success",
  props<{ settings: InstagramLoginSetting }>()
);
export const getInstagramLoginFailureAction = createAction(
  "[InstagramLogin] Get Settings Failure",
  props<{ error: string }>()
);

export const getInstagramLoginUrlInitAction = createAction(
  "[InstagramLogin] Get Login Url Init"
);
export const getInstagramLoginUrlSuccessAction = createAction(
  "[InstagramLogin] Get Login Url Success",
  props<{ url: string }>()
);
export const getInstagramLoginUrlFailureAction = createAction(
  "[InstagramLogin] Get Login Url Failure",
  props<{ error: string }>()
);

const actions = joinActions({
  postUnbindInstagramLoginInitAction,
  postUnbindInstagramLoginSuccessAction,
  postUnbindInstagramLoginFailureAction,
  postBindInstagramLoginInitAction,
  postBindInstagramLoginSuccessAction,
  postBindInstagramLoginFailureAction,
  getInstagramLoginInitAction,
  getInstagramLoginSuccessAction,
  getInstagramLoginFailureAction,
  getInstagramLoginUrlInitAction,
  getInstagramLoginUrlSuccessAction,
  getInstagramLoginUrlFailureAction,
});

export type InstagramLoginApiAction = typeof actions;
